import Swal, {SweetAlertIcon, SweetAlertOptions} from 'sweetalert2';
import MusculaLog from '@muscula.com/muscula-webapp-js-logger';
import Toastify from 'toastify-js';

export function confirmAction(text: string, onOK: () => void) {
    return Swal.fire({
        title: 'Are you sure?',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
    } as SweetAlertOptions)
        .then((r) => {
            if (r.value) {
                onOK();
            }
        }).catch(() => {
            //ignore
        });
}

export function saveSuccess(onOK: () => void) {
    return Swal.fire({
        title: 'Done!',
        text: 'All changes saved!',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
    } as SweetAlertOptions)
        .then(() => {
            onOK();
        })
        .catch(() => {
            //ignore
        });
}

export function showAlert(title: string, text: string, icon: SweetAlertIcon) {
    Swal.fire({
        title,
        text,
        icon,
    });
}

export function showError(title: string, text: string, exception: any) {
    MusculaLog.Error(title + ' ' + text, exception);
    showAlert(title, text, 'error');
    console.error(title, exception);
}

export function showWarning(title: string, text: string) {
    showAlert(title, text, 'warning');
}

export function showCommunicationError(err: any) {
    if (err && err.status === 401) {
        showUnauthorizedError();
        return;
    }

    console.error('Error when loading data', err);
    Toastify({
        text: 'Error when loading data. Please try again later',
        duration: 5000,
        close: true,
        gravity: 'bottom',
        position: 'right',
        backgroundColor: '#C31010',
        stopOnFocus: true,
        onClick: function() {
        },
    }).showToast();
}

export function showNotFoundToast() {
    Toastify({
        text: 'Element not found',
        duration: 5000,
        close: true,
        gravity: 'bottom',
        position: 'right',
        backgroundColor: '#C31010',
        stopOnFocus: true,
        onClick: function() {
        },
    }).showToast();
}

export function showUnauthorizedError() {
    Toastify({
        text: 'Error when loading data. You have no access to this resource.',
        duration: 5000,
        close: true,
        gravity: 'bottom',
        position: 'right',
        backgroundColor: '#C31010',
        stopOnFocus: true,
        onClick: function() {
        },
    }).showToast();
}

export function showDefaultError(exception: any) {
    MusculaLog.Error('Something is wrong', exception);
    showError('Oops!', 'Something is wrong. Please try again later', exception);
}

export function showValidationError() {
    showAlert('Validation error', 'Please fill form correctly', 'warning');
}

export function showDemoModeWarning() {
    showWarning('Demo mode', 'Cannot make changes in demo mode');
}
